import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Check } from "lucide-react";
import { Format } from "@/data/agendaData";
import { cn } from "@/lib/utils";

interface FormatSelectorProps {
  formats: Format[];
  selectedFormatId?: number;
  onFormatSelect: (formatId: number) => void;
}

export const FormatSelector = ({
  formats,
  selectedFormatId,
  onFormatSelect,
}: FormatSelectorProps) => {
  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-2xl font-bold mb-2">1. Elige tu Formato</h2>
        <p className="text-muted-foreground">
          Selecciona cómo quieres organizar tu agenda
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {formats.map((format) => {
          const isSelected = selectedFormatId === format.id;

          return (
            <Card
              key={format.id}
              className={cn(
                "cursor-pointer transition-all hover:shadow-lg hover:scale-[1.02]",
                isSelected && "ring-2 ring-primary shadow-lg"
              )}
              onClick={() => onFormatSelect(format.id)}
            >
              <CardHeader>
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <CardTitle className="flex items-center gap-2">
                      {format.name}
                      {format.popular && (
                        <Badge variant="secondary" className="text-xs">
                          Popular
                        </Badge>
                      )}
                    </CardTitle>
                    <CardDescription className="mt-1">
                      {format.description}
                    </CardDescription>
                  </div>
                  {isSelected && (
                    <div className="ml-2 flex-shrink-0">
                      <div className="rounded-full bg-primary p-1">
                        <Check className="h-4 w-4 text-primary-foreground" />
                      </div>
                    </div>
                  )}
                </div>
              </CardHeader>

              <CardContent>
                <div className="space-y-2 text-sm">
                  <div className="flex justify-between">
                    <span className="text-muted-foreground">Páginas por día:</span>
                    <span className="font-medium">{format.pagesPerDay}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-muted-foreground">Total páginas:</span>
                    <span className="font-medium">{format.totalPages}</span>
                  </div>
                  <div className="flex justify-between pt-2 border-t">
                    <span className="font-semibold">Precio base:</span>
                    <span className="font-bold text-lg">
                      ${format.basePrice.toFixed(2)}
                    </span>
                  </div>
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  );
};
